// event.code and even.key doesn't match with the game keys that we are using
// workaround for those keys, TODO need to find a better solution
const KeyCodesMap = {
    get (event) {
        if (event.code === 'NumpadAdd') {
            return 'numpad +';
        }
        if (event.code === 'NumpadSubtract') {
            return 'numpad -';
        }
        if (event.code === 'Equal') {
            return '=';
        }
        if (event.code === 'Minus') {
            return '-';
        }
        if (event.code === 'Escape') {
            return 'esc';
        }
        return event.code.toLowerCase();
    }
};

const getAllAvailableKeyCodes = function() {
    return ['space', 'enter', 'esc', 'numpad +', 'numpad -', '=', '-'];
};

const keyboard = {
    isEnabled: false,
    locks: [],
    isGameKeysEnabled: true,
    enabledKeyMap: getAllAvailableKeyCodes(),
    staticHandlerMap: {},
    uiHandlerMap: {},

    lock (locker) {
        if (!this.locks.includes(locker)) {
            this.locks.push(locker);
        }
    },

    unlock (locker) {
        const index = this.locks.indexOf(locker);

        if (index >= 0) {
            this.locks.splice(index, 1);
        }
    },

    enable (keys) {
        this.isEnabled = true;
    },

    getAllAvailableKeyCodes,

    disable () {
        this.isEnabled = false;
    },

    enableGameKeys () {
        this.isGameKeysEnabled = true;
    },

    disableGameKeys () {
        this.isGameKeysEnabled = false;
    },

    enableHandlers (keys) {
        for (let i = 0; i < keys.length; i++) {
            if (!this.enabledKeyMap.includes(keys[i])) {
                this.enabledKeyMap.push(keys[i]);
            }
        }
    },

    enableHandlersOnly (keys) {
        this.enabledKeyMap = keys.map(key => key.toLowerCase());
    },

    disableHandlers (keys) {
        for (let i = 0; i < keys.length; i++) {
            const index = this.enabledKeyMap.indexOf(keys[i])
            if (index !== -1) {
                this.enabledKeyMap.splice(index, 1);
            }
        }
    },

    registerUIHandlers (keys, handler) {
        keys.forEach((key) => {
            let array;

            key = key.toLowerCase();

            if (this.uiHandlerMap.hasOwnProperty(key)) {
                array = this.uiHandlerMap[key];
            } else {
                array = [];
                this.uiHandlerMap[key] = array;
            }
            array.push(handler);
        });
    },

    registerHandler (keys, handler) {
        keys.forEach((key) => {
            let array;

            key = key.toLowerCase();

            if (this.staticHandlerMap.hasOwnProperty(key)) {
                array = this.staticHandlerMap[key];
            } else {
                array = [];
                this.staticHandlerMap[key] = array;
            }
            array.push(handler);
        });
    },

    unregisterHandler (handler) {
        for (const key in this.staticHandlerMap) {
            if (Object.prototype.hasOwnProperty.call(this.staticHandlerMap, key)) {
                const handlers = this.staticHandlerMap[key];

                this.staticHandlerMap[key] = handlers.filter((item) => {
                    return item !== handler;
                });
            }
        }
    }
};

setTimeout (() => {
    document.addEventListener('keyup', (event) => {
        if (!keyboard.isEnabled || keyboard.locks.length) {
            return;
        }
        const keyCode = KeyCodesMap.get(event);

        if (keyboard.enabledKeyMap.includes(keyCode)) {
            if (keyboard.staticHandlerMap.hasOwnProperty(keyCode) && keyboard.isGameKeysEnabled) {
                const handlers = keyboard.staticHandlerMap[keyCode];

                handlers.forEach((hndl) => {
                    hndl(event);
                });
            }

            if (keyboard.uiHandlerMap.hasOwnProperty(keyCode)) {
                const handlers = keyboard.uiHandlerMap[keyCode];

                handlers.forEach((hndl) => {
                    hndl(event);
                });
            }
        }
    });
}, 2000);

export default keyboard;
